import { CATEGORIES_TYPES } from "redux/reducers/categories/categoriesTypes";
import { api_get, api_post } from "services/api";
import { startRequest, stopRequest, setSnackbar } from "../search/searchActions";

const {
    GET_CATEGORIES
} = CATEGORIES_TYPES

const url = `${process.env.REACT_APP_URL_INTEGRATIONS}/categories`;

const qid = `KZDut9V3GRvS9KeD`;

export const getCategories = () => {
    let getCategoriesUrl = `${url}?qid=${qid}`;
    return async (dispatch) => {
        dispatch(startRequest())
        await api_get(getCategoriesUrl).then(resp => {
            dispatch({
                type: GET_CATEGORIES,
                payload: resp
            })
            dispatch(stopRequest())
        }).catch(err => {
            dispatch(setSnackbar(err))
            dispatch(stopRequest())
        })
    }
}